<template>
    <div class="page page--home home">
        <div class="cta">
            <div class="cta__content">
                <p class="cta__content__title">
                    {{$t('home.cta.title')}}
                </p>
                <div class="cta__content__text" v-html="$t('home.cta.text')">
                </div>
            </div>
        </div>
        <div class="page__content">
            <div class="page__content__block">
                <div>
                    <h1>{{$t('home.title')}}</h1>
                </div>
                <div v-html="$t('home.text')"></div>
            </div>
        </div>
        <div class="page__content">
            <div class="home__blocks">
                <div class="home__blocks__block home__blocks__block--accom">
                    <div class="home__blocks__block__title">{{$t('home.accommodation.title')}} <fa-icon icon="bed"></fa-icon></div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/home/iglo.png" alt="Iglo 2021">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('home.accommodation.text')"></div>
                    <router-link to="/accommodatie" class="button home__blocks__block__button">{{$t('home.accommodation.link')}}</router-link>
                </div>
                <div class="home__blocks__block home__blocks__block--activities">
                    <div class="home__blocks__block__title">{{$t('home.activities.title')}} <fa-icon icon="hiking"></fa-icon></div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/home/husky.jpg" alt="Husky slee">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('home.activities.text')"></div>
                    <router-link to="/activiteiten" class="button home__blocks__block__button">{{$t('home.activities.link')}}</router-link>
                </div>
                <div class="home__blocks__block home__blocks__block--environment">
                    <div class="home__blocks__block__title">{{$t('home.environment.title')}} <fa-icon icon="tree"></fa-icon></div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/home/noorderlicht.jpg" alt="Noorderlicht">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('home.environment.text')"></div>
                    <router-link to="/omgeving" class="button home__blocks__block__button">{{$t('home.environment.link')}}</router-link>
                </div>
                <div class="home__blocks__block home__blocks__block--contact">
                    <div class="home__blocks__block__title">{{$t('home.contact.title')}} <fa-icon icon="envelope-open-text"></fa-icon></div>
                    <div class="home__blocks__block__image">
                        <img src="../assets/img/home/uitbaters.jpg" alt="Noorderlicht">
                    </div>
                    <div class="home__blocks__block__text" v-html="$t('home.contact.text')"></div>
                    <router-link to="/contact" class="button home__blocks__block__button">{{$t('home.contact.link')}}</router-link>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'Home'
    }
</script>
